import axios, { AxiosRequestConfig } from "axios";
import { HOST_API } from "src/config-global";
import { paths } from "src/routes/paths";

const axiosInstance = axios.create({ baseURL: HOST_API });

export const STORAGE_KEY = "accessToken";
export const REFRESH_KEY = "refreshToken";

axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem(STORAGE_KEY);
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data.error === "トークンの期限切れです。"
    ) {
      setSession(null);
      window.location.href = paths.auth.login;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    sessionStorage.setItem(STORAGE_KEY, accessToken);
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    sessionStorage.removeItem(STORAGE_KEY);

    delete axiosInstance.defaults.headers.common.Authorization;
  }
};

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosInstance.get(url, { ...config });
  return res.data;
};

export const endpoints = {
  auth: {
    login: `/admin/login`,
    logout: `/admin/logout`,
    changePassword: `/admin/maintener/users/self/password`,
  },
  accounts: {
    root: `/admin/maintener/users`,
    detail: `/admin/maintener/users/{id}`,
    create: `/admin/maintener/users`,
    update: `/admin/maintener/users/{id}`,
    delete: `/admin/maintener/users/{id}`,
  },
  users: {
    root: `/admin/customer`,
    bulkStatus: `/admin/customer/edit`,
  },
  operations: {
    suspend: `/admin/maintenance/history`,
    maintenanceHistory: `/admin/maintenance/history`,
    termsConsent: `/admin/terms/history`,
    termsConsentHistory: `/admin/terms/history`,
    updateNotification: `/admin/verup/history`,
    updateNotificationHistory: `/admin/verup/history`,
    municipalityData: `/admin/import/file`,
    municipalityDataPreview: `/admin/import/preview`,
    municipalityDataHistory: `/admin/import/history`,
    municipalityDataDownload: `/admin/import/download/{id}`,
  },
  notifications: {
    root: "/admin/notification/history",
    send: "/admin/notification/send",
  },
};
